<template>
  <el-container class="process-design-container">
    <el-header height="45px" class="process-design-header">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>流程设计</el-breadcrumb-item>
        <el-breadcrumb-item class="process-name" v-if="!nameAttr.showNameInput"><span v-if="processDefinition" :title="processDefinition.name">{{processDefinition.name || '未命名'}}</span>
          <i class="el-icon-edit-outline name" @click="changeName"></i>
        </el-breadcrumb-item>
        <el-input class="name-input" ref="nameInput" v-else v-model="processDefinition.name" @change="saveName" @blur="saveName"  @keyup.esc.native="recallName"></el-input>
      </el-breadcrumb>
      <div class="process-tabs">
        <span :class='{"activeTab":page.activeItem==="chart"}' @click="changeActive('chart')"> <a>流程图</a> </span>
        <span :class='{"activeTab":page.activeItem==="flowform"}' @click="changeActive('flowform')"> <a>流程表单</a></span>
      </div>
      <div class="header-buttons">
         <el-dropdown split-button type="primary" @click="save">
           <i v-if="saveAccomplish" class="el-icon-loading"></i>
           保存
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item><a @click="saveAndClose">保存并关闭</a></el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button :class="{'loading-attr-button': isloadingAttr}" type="primary" @click="openAttributeDialog">属性</el-button>
        <span class='fullScreen' :title="isFullScreen?`退出全屏`:`全屏`" :class="[isFullScreen?'exit':'']"
              @click="toggleFullScreen"></span>
      </div>
    </el-header>
    <process-chart
     v-if="processDefinition&&page.activeItem==='chart'"
     ref='processChart'
      :definition="processDefinition"
      :currentTask="currentTask"
      @addNode="addNode"
      @updatePosition="updatePosition"
      @selectPerson="selectPerson"
      @removeNode="removeNode"
      @setCurrentNodeId="getCurrentNodeId"
      @openDialogInform="openDialogInform"
     ></process-chart>
    <component-design ref="componentDesign" v-if="processDefinition&&page.activeItem==='flowform'"
                      :form="getForm"
                      :nodeIsCountersign="currentTaskIsCountersign"
                      :currentNodeFormId="currentNodeFormId"
                      :processSaveState="processSaveState">
       <label slot="process">
          <el-tabs class="procee-form-tab" v-model="currentTask"  type="card" @tab-click="handleClick">
            <el-tab-pane v-for="(item, index) in getUsedNodes" :label="item.name" :name="item.id" :key="index" :disabled="item.disabled"></el-tab-pane>
          </el-tabs>
        </label>
    </component-design>
    <form-design-dialog v-if="page.dialog.visible" :page="page" @finishCheckDefinition='finishCheckDefinition'></form-design-dialog>

    <process-select-person
      v-if="processDefinition"
      :nodes="processDefinition.process.nodes"
      :allData="selectPersonDialog.allPerson"
      :candidates="selectPersonDialog.node.candidates"
      :candidateShowNode="selectPersonDialog.node.candidateShowNode"
      :candidateRequired="selectPersonDialog.node.candidateRequired"
      :dialogVisible="selectPersonDialog.dialogVisible"
      :selectType="selectPersonDialog.selectType"
      @saveSelectPerson="saveSelectPerson"
      @closeDialog="closeDialog"></process-select-person>

    <process-dialog-inform v-if="informDialog&&informDialog.dialogVisible" :inform="informDialog" :nodes="getNodes"  :currentTaskNode="currentTaskNode"></process-dialog-inform>
    <process-dialog-attribute v-if="attributeDialog.dialogVisible" :attribute="attributeDialog" :definition="processDefinition"></process-dialog-attribute>
  </el-container>
</template>

<script>
import FormDesignDialog from '@/components/form/design/form-design-dialog.vue'
import ComponentDesign from '@/components/form/design/component-design.vue'
import ProcessChart from './process-chart.vue'
import {fullscreenMixin} from '../../shared/designMixins/mixins'
import ProcessSelectPerson from './process-dialog-select-person'
import ProcessDefinition from '@/store/process/definition'
import Schema from '@/store/form/schema'
import FormService from '@/store/form/formService'
import ProcessService from '@/store/process/processService'
import { ProcessComponent, ColumnComponent } from '@/store/form/component'
import { FormComponent } from '@/store/form/component.js'
import {getProperties} from '@/store/form/componentDefaults.js'
import ProcessDialogInform from './process-dialog-inform'
import ProcessDialogAttribute from './process-dialog-attribute'
import _ from 'lodash'
import { UUID } from '@/plugins/common'

export default {
  name: 'ProcessDesign',
  props: ['id'],
  mixins: [fullscreenMixin],
  provide: {
    formService: new FormService(),
    processService: new ProcessService(),
    componentGraggable: {
      isAllow: true
    },
    componentCount: {},
    sortComponent: {}
  },
  data () {
    return {
      schema: new Schema(),
      currentTask: '',
      processDefinition: null,
      processComponent: {},
      appProcessModel: {},
      selectPersonDialog: {
        dialogVisible: false,
        node: {},
        allPerson: [],
        selectType: 'user'
      },
      page: {
        dialog: {visible: false, title: '', view: ''},
        activeItem: 'chart',
        processName: '',
        clickType: ''
      },
      informDialog: null,
      attributeDialog: {
        dialogVisible: false,
        active: 'first',
        componentInteraction: [],
        formValidates: [],
        formScreen: ''
      },
      // 保存加载标志
      saveAccomplish: false,
      // 流程属性加载中标志
      isloadingAttr: false,
      nameAttr: {
        showNameInput: false,
        oldName: ''
      },
      processValue: {
        processDefinition: '',
        processComponent: ''
      },
      sortComponent: {
        state: false
      },
      // 保存后需要重新排序状态
      processSaveState: false
    }
  },
  components: {
    ProcessSelectPerson,
    FormDesignDialog,
    ComponentDesign,
    ProcessChart,
    ProcessDialogInform,
    ProcessDialogAttribute
  },
  created () {
    this._provided.componentCount = {}
    this._provided.formService.loadTables()
    this._provided.sortComponent = this.sortComponent
    this._provided.processService.processVue = this
    this.fullscreenchange()
    if (this.id) {
      this.editProcessById(this.id)
    } else {
      this.initProcessDefinition()
      this.currentTask = this.processDefinition.process.startNode
    }
    this._provided.formService.loadDataReports()
  },

  methods: {
    editProcessById (id) {
      return this.$axios.get(`/process-api/processes/${id}?isEdit=true`).then(res => {
        let processDefinition = ProcessDefinition.load(res.data.definition)
        this.processDefinition = processDefinition
        this.processValue.processDefinition = JSON.stringify(processDefinition)
        this.schema.load(res.data.schema)
        this._provided.formService.schema = this.schema

        let processComponent = ProcessComponent.load(res.data.component)
        this.processComponent = processComponent
        this.processValue.processComponent = JSON.stringify(processComponent)
        this._provided.formService.component = this.processComponent
        this._provided.processService.formService = this._provided.formService

        this._provided.processService.processDefinition = this.processDefinition
        this.currentTask = this.processDefinition.process.startNode
        // 流程加载完成
        this.isloadingAttr = false
      })
    },
    initProcessDefinition () {
      this.processDefinition = ProcessDefinition.create()
      let nodes = this.processDefinition.process.nodes.filter(m => m.type === 'userTask')
      let schema = new Schema()
      this.processComponent = ProcessComponent.create()
      this._provided.formService.component = this.processComponent
      this.processDefinition.process.formId = this.processComponent.id
      schema.createTable(this.processComponent.archive.tableId, '流程')
      schema.tables && schema.tables.length && schema.tables.forEach(async t => {
        if (!t.pinyinName || !t.pinyinFirstChar) {
          let pingyin = await this._provided.formService.getPinyinByHanzi(t.name)
          _.merge(t, {...pingyin})
        }
        t.columns && t.columns.length && t.columns.forEach(async c => {
          if (!c.pinyinName || !c.pinyinFirstChar) {
            let pingyin = await this._provided.formService.getPinyinByHanzi(c.name)
            _.merge(c, {...pingyin})
          }
        })
      })
      this._provided.formService.schema = schema
      nodes.forEach(async m => {
        let component = getProperties('rc-form')
        component.defaults.archive.enable = false
        component.defaults.name = m.name
        component.defaults.id = m.formId
        let c = FormComponent.create(component.defaults)
        if (!c.pinyinName || !c.pinyinFirstChar) {
          let pingyin = await this._provided.formService.getPinyinByHanzi(c.name)
          _.merge(c, {...pingyin})
        }
        this._provided.formService.component.children.push(c)
      })

      this._provided.processService.formService = this._provided.formService
      this._provided.processService.processDefinition = this.processDefinition
      this._provided.processService.appProcessModel = this.appProcessModel
      // 流程加载完成
      this.isloadingAttr = false
    },
    getCurrentNodeId (currentNodeId) {
      this.currentTask = currentNodeId
      let node = this.processDefinition.process.nodes.find(n => n.id === currentNodeId)
      this._provided.componentGraggable.isAllow = !(node.type === 'inclusiveGateway_start' || node.type === 'inclusiveGateway_end')
    },
    changeActive (index) {
      if (index === 'chart') {
        this.isCloseComponentAttr()
          .then(() => {
            this.page.activeItem = index
          })
          .catch()
      } else {
        this.page.activeItem = index
      }
    },
    handleClick (tab) {
      this.currentTask = tab.name
      this.changeCurrentNode(tab.name)
    },
    changeCurrentNode (value) {
      // 关闭属性面板
      this.$refs.componentDesign.change({state: 'ComponentList', id: 'null'})
      // 为了获取当前节点前的节点的控件
      let path = []
      this.processDefinition.process.getPaths(value)[0].split('->').forEach(m => {
        path.push(this.processDefinition.process.nodes.find(n => n.id === m).formId)
      })
      this._provided.processService.formService.component.path = path

      let node = this.processDefinition.process.nodes.find(n => n.id === value)
      this._provided.componentGraggable.isAllow = !(node.type === 'inclusiveGateway_start' || node.type === 'inclusiveGateway_end')
    },
    // 控件的属性保存
    isCloseComponentAttr () {
      if (this.$refs.componentDesign && this.$refs.componentDesign.$refs.ComponentAttr && this.$refs.componentDesign.$refs.ComponentAttr.component) {
        this.$message({
          message: '请先保存控件属性',
          center: true,
          duration: 3000,
          customClass: 'without-execute-dialog'
        })
        return Promise.reject(new Error('请先保存控件属性'))
      } else {
        return Promise.resolve()
      }
    },
    // 属性节点的保存
    isCloseNodeAttr () {
      let connections = _.cloneDeep(this._provided.processService.getConections(this.currentTask))
      if (this.$refs.processChart && JSON.stringify(connections) !== JSON.stringify(this.$refs.processChart.connections)) {
        this.$message({
          message: '请先保存节点流转线属性',
          center: true,
          duration: 3000,
          customClass: 'without-execute-dialog'
        })
        return Promise.reject(new Error('请先保存控件属性'))
      } else {
        return Promise.resolve()
      }
    },
    // 会签节点校验
    countersignNode () {
      if (this.$refs.processChart) {
        return this.$refs.processChart.nodeAttrValidate()
          .then(() => this.connectionOfCountersign())
      } else {
        return this.connectionOfCountersign()
      }
    },
    // 会签节点流转线的校验
    connectionOfCountersign () {
      return new Promise((resolve, reject) => {
        let countersignNode = this.processDefinition.process.nodes.filter(n => n.isCountersign)
        countersignNode.forEach(m => {
          let nodeComponent = this.processComponent.children.find(n => n.id === m.formId)
          if (nodeComponent.archivedChildren.length !== 0) {
            this.$message.error('会签节点不允许存在控件')
            reject(new Error('会签节点不允许存在控件'))
          }
          let connections = this.processDefinition.process.connections.filter(n => n.sourceNodeId === m.id)
          if (connections.length !== 2) {
            this.$message.error('会签节点有且仅有两条流转线')
            reject(new Error('会签节点有且仅有两条流转线'))
          } else {
            let actionIds = []
            connections.forEach(el => {
              if (el.actionId) actionIds.push(el.actionId)
            })
            let newActionIds = [...new Set(actionIds)]
            if (newActionIds.length < 2) {
              this.$message.error('会签节点有且仅有两条流转线,并且不同的操作按钮')
              reject(new Error('会签节点有且仅有两条流转线，并且不同的操作按钮'))
            } else {
              if (!(newActionIds.includes(m.agreedActionId) && newActionIds.includes(m.disAgreedActionId))) {
                this.$message.error('会签节点流转有且只有两个会签按钮的流转线')
                reject(new Error('会签节点流转有且只有两个会签按钮的流转线'))
              }
            }
          }
        })
        resolve()
      })
    },
    save () {
      // 如果正在保存中,则不做任何操作
      if (this.saveAccomplish) {
        return false
      }
      this.saveAccomplish = true
      this.page.clickType = 'save'
      // 保存
      this.publish()
    },
    saveAndClose () {
      // 如果正在保存中,则不做任何操作
      if (this.saveAccomplish) {
        return false
      }
      this.saveAccomplish = true
      this.page.clickType = 'saveclose'
      this.publish()
    },
    // 判断节点按钮中，是否包含有流转或者自定义按钮
    verifyButtonType () {
      return new Promise((resolve, reject) => {
        let nodes = this.processDefinition.process.nodes
        if (nodes.length) {
          // 拿到使用的节点
          nodes = nodes.filter(e => e.type === 'userTask')
        }
        nodes && nodes.forEach(node => {
          if (node.actions.length !== 0) {
            if (node.actions.filter(action => action.type === '流转' || action.type === '自定义').length === 0) {
              this.$message.error('每个节点必须有一个流转或自定义类型按钮')
              reject(new Error('每个节点必须有一个流转或自定义类型按钮'))
            }
          } else {
            this.$message.error('每个节点必须有一个流转或自定义类型按钮')
            reject(new Error('每个节点必须有一个流转或自定义类型按钮'))
          }
        })
        resolve()
      })
    },
    publish () {
      if (this.processDefinition.name === '') {
        this.openDialog('changeProcessNameDialog', '流程名称设置')
        this.saveAccomplish = false
      } else {
        this.checkDefinitionName()
          .then((res) => {
            if (res) {
              this.verifyButtonType()
                .then(() => this.isCloseNodeAttr())
                .then(() => this.isCloseComponentAttr())
                .then(() => this.countersignNode())
                .then(() => this.validate())
                .finally(() => {
                  this.saveAccomplish = false
                })
            } else {
              this.$message.info('该流程名称已存在，请更换流程名称')
              this.saveAccomplish = false
            }
          })
      }
    },
    checkDefinitionName () {
      return this.$axios.get(`/process-api/processes/${this.processDefinition.id}/validateProcessName`, {params: { 'name': this.processDefinition.name }})
        .then(res => res.data)
    },
    async handleBeforePublic () {
    // 中途归档修正
      let endEventNode = this.processDefinition.process.nodes.find(node => node.type === 'endEvent')
      let line = this.processDefinition.process.connections.find(line => line.targetNodeId === endEventNode.id)
      let nodeArchiveOptions = line && this.processDefinition.process.nodes.filter(node => node.type === 'userTask').filter(node => node.id !== line.sourceNodeId)
      if (nodeArchiveOptions === undefined || !nodeArchiveOptions.length) {
        this.processDefinition.process.attribute.allNodeArchiveEnable = false
      }
      if (this.page.clickType === 'save') {
        await this.submit()
          .then(async () => {
            let processId = this.id ? this.id : this.processDefinition.id
            await this.editProcessById(processId)
            // 重新排序控件
            this.processSaveState = true
            this.tips()
          })
      } else if (this.page.clickType === 'saveclose') {
        await this.submit()
          .then(() => this.closeProcess())
      }
      // 重置保存排序状态
      this.processSaveState = false
    },
    changeDefinitionName () {
      this.page.clickType = 'changeName'
      this.openDialog('changeProcessNameDialog', '流程名称设置')
    },
    changeName () {
      this.nameAttr.name = this.processDefinition.name
      this.nameAttr.showNameInput = true
      this.$nextTick(() => {
        this.$refs.nameInput.focus()
        this.$refs.nameInput.select()
      })
    },
    saveName () {
      if (!this.processDefinition.name) {
        this.$message.info('流程名称为空')
      }
      this._provided.processService.formService.component.name = this.processDefinition.name
      this._provided.formService.updataArchiveName(this._provided.processService.formService.component)
      this._provided.processService.changeDefinitionName(this.processDefinition.name)
      this.nameAttr.showNameInput = false
    },
    // esc撤回
    recallName () {
      this.processDefinition.name = this.nameAttr.name
      this.nameAttr.showNameInput = false
    },
    validate () {
      return this.handleBeforePublic()
    },
    submit () {
      return this._provided.processService.publish()
    },
    tips () {
      this.$message({
        message: '流程保存成功',
        center: true,
        customClass: 'message-form-save',
        type: 'success',
        duration: 3000
      })
    },
    openDialog (view, title) {
      this.page.dialog = {
        visible: true,
        view,
        title
      }
      this.page.processName = this.processDefinition.name
      this.page.id = this.processDefinition.id
    },
    openAttributeDialog () {
      if (!this.processDefinition) {
        this.isloadingAttr = true
        return this.$message.warning('请稍候，正在加载')
      }
      this.attributeDialog.dialogVisible = true
      // 控件交互的执行的控件的是数组
      let componentInteraction = this.$_.cloneDeep(this._provided.processService.formService.component.properties.componentInteraction)
      if (componentInteraction) {
        componentInteraction.forEach(m => {
          // 手动添加一个id给vue区分
          if (!m.id) {
            m.id = UUID.create()
          }
          if (!m.triggerComponents) {
            m.relation = true
            m.triggerComponents = [{triggerComponent: m.triggerComponent, triggerType: m.triggerType, compareVal: m.compareVal}]
            delete m.triggerComponent
            delete m.triggerType
            delete m.compareVal
          }
          m.conforms.forEach(n => {
            n.changeComponent = typeof (n.changeComponent) === 'string' ? n.changeComponent.split(',') : n.changeComponent
          })
          m.noConforms.forEach(n => {
            n.changeComponent = typeof (n.changeComponent) === 'string' ? n.changeComponent.split(',') : n.changeComponent
          })
        })
      }
      // 控件交互倒序: 取的时候取反
      this.attributeDialog.componentInteraction = componentInteraction ? componentInteraction.reverse() : []

      let formValidates = []
      this._provided.processService.formService.component.formValidates && this._provided.processService.formService.component.formValidates.forEach(m => {
        m.operationType = []
        formValidates.push(m)
      })
      this.attributeDialog.formValidates = formValidates

      // 显示大小的
      this.attributeDialog.formScreen = this.$_.cloneDeep(this._provided.processService.formService.component.properties.formScreen)
    },
    finishCheckDefinition (processName) {
      this._provided.processService.formService.component.name = processName
      this._provided.processService.formService.updataArchiveName(this._provided.processService.formService.component)
      this._provided.processService.changeDefinitionName(processName)
      this.processDefinition.name = processName
      this.$message({
        message: '流程名称保存成功',
        center: true,
        customClass: 'message-form-save',
        type: 'success',
        duration: 2000
      })
      if (this.page.clickType === 'save') {
        this.submit().then(async () => {
          let processId = this.id ? this.id : this.processDefinition.id
          await this.editProcessById(processId)
          this.processSaveState = true
          this.tips()
        })
      } else if (this.page.clickType === 'saveclose') {
        this.submit()
          .then(() => this.closeProcess())
      }
      this.processSaveState = false
    },
    // 打开流转通知弹窗
    openDialogInform (inform) {
      this.informDialog = this.$_.cloneDeep(inform)
    },
    closeProcess () {
      this.resetProcess()
      this.$emit('closeForm')
    },
    resetProcess () {
      this._provided.processService.reset()
    },
    addNode (node) {
      this._provided.processService.addNode(node)
      this.$nextTick(() => {
        this.$refs.processChart.selectNodeiId(node.id)
      })
    },
    removeNode (nodeId) {
      this._provided.processService.removeNode(nodeId)
    },
    updatePosition (node) {
      this._provided.processService.updatePosition(node)
    },
    selectPerson (object) {
      this.selectPersonDialog.node = this.processDefinition.process.nodes.find(m => m.id === object.nodeId)
      if (this.selectPersonDialog.node.candidateShowNode === '无') {
        this.selectPersonDialog.node.candidateShowNode = ''
      } else if (!this.selectPersonDialog.node.candidateShowNode) {
        let connection = this.processDefinition.process.getParentNode(this.selectPersonDialog.node.id)
        if (connection) {
          this.selectPersonDialog.node.candidateShowNode = connection[0].sourceNodeId
        }
      }
      if (object.way === 'user') {
        this.selectPersonDialog.selectType = 'user'
        this.selectPersonDialog.allPerson = []
      } else if (object.way === 'component') {
        this.selectPersonDialog.selectType = 'component'
        let allData = []
        let nodes = this.getpreviousNodes(this.currentTask)
        nodes.forEach(el => {
          let form = _.cloneDeep(this._provided.processService.formService.getComponentById(el.formId))
          let children = form.archivedChildren.filter(m => m instanceof ColumnComponent)
          //  控件取的是columnId
          // fixme 最好不用深度监听
          children.forEach(m => {
            m.id = m.archive.columnId
          })
          allData.push({id: form.id, name: form.name, componentType: form.componentType, children: children})
        })
        this.selectPersonDialog.allPerson = allData
      }

      this.selectPersonDialog.dialogVisible = true
    },
    // 当前节点前的全部节点
    getpreviousNodes (currentTask) {
      let nodeIds = []
      let nodes = []
      nodeIds = this.processDefinition.process.getpreviousNode(currentTask).filter(n => n !== currentTask)
      nodeIds.forEach(m => {
        // 获取当前节点及之前的节点id集合
        nodes.push(this.processDefinition.process.nodes.find(n => n.id === m))
      })
      return this.processDefinition.process.getwithoutinClusiveGateway(nodes)
    },
    closeDialog () {
      this.selectPersonDialog.dialogVisible = false
    },
    saveSelectPerson (param) {
      param.nodeId = this.selectPersonDialog.node.id
      this._provided.processService.saveSelectPerson(param)
      this.selectPersonDialog.dialogVisible = false
      this.selectPersonDialog.nodeId = ''
    }
  },
  computed: {
    currentTaskNode () {
      let node = null
      let cNode = this.processDefinition && this.processDefinition.process.nodes.find(m => m.id === this.currentTask)
      if (cNode) {
        node = cNode
      }
      return node
    },
    currentTaskIsCountersign () {
      let notAllow = false
      if (this.currentTaskNode) {
        // 网关和会签节点不允许拖控件
        notAllow = this.currentTaskNode.isCountersign || this.currentTaskNode.type === 'inclusiveGateway_start' || this.currentTaskNode.type === 'inclusiveGateway_end'
        return notAllow
      }
    },
    currentNodeFormId () {
      return this.getNodes.find(e => e.id === this.currentTaskNode.id) && this.getNodes.find(e => e.id === this.currentTaskNode.id).formId
    },
    getUsedNodes () {
      return this.getNodes.map(m => {
        if (m.type === 'inclusiveGateway_start' || m.type === 'inclusiveGateway_end') {
          m.disabled = true
        }
        return m
      })
    },
    getNodes () {
      return this.processDefinition.process.nodes.filter(m => {
        return m.type !== 'endEvent' && m.type !== 'cancelEvent'
      })
    },
    getForm () {
      let formId = this.processDefinition.process.nodes.find(m => m.id === this.currentTask).formId
      return this._provided.formService.component.children.find(m => m.id === formId)
    }
  },
  watch: {
    // 控件如果改变了顺序，是前端手动排序的，和返回的数据结构上会有差异，需要在排序完成之后再保存
    sortComponent: {
      handler (val) {
        if (val.state) {
          this.processValue.processComponent = JSON.stringify(this.processComponent)
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="scss">
  @import '@/assets/scss/common.scss';

  .process-design-container {
    height: 100%;
    .process-design-header {
      background: #fff;
      line-height: 45px;
      box-shadow: 4px 4px 4px rgba(174, 222, 251, 0.1);
      padding: 0 12px 0 26px;
      position: relative;
      &:after {
        content: "";
        display: block;
        clear: both;
      }
      .el-breadcrumb {
        display: inline-block;
        line-height: 45px;
        height: 100%;
        position: relative;
        margin-right: 14px;
        cursor: pointer;

        span {
          font-weight: 700;
          font-size: 15px;

          &:hover {
            font-weight: 700;
          }
          &.process-name >span >span{
           max-width: 200px;
           height: 45px;
           display: inline-block;
           overflow: hidden;
           vertical-align: top;
           white-space: nowrap;
           text-overflow: ellipsis;
         }
        }
        .name {
          vertical-align: middle;
          margin-left: 10px;
          color: #409EFF;
          cursor: pointer;
        }
        .name-input {
          display: inline-block;
          width: 200px;
        }
      }
      .process-tabs {
        position: absolute;
        border: 1px solid #fff;
        left: 50%;
        margin-left: -70px;
        top: 0;
        span {
          border-bottom: 2px solid transparent;
          display: inline-block;
          height: 100%;
          position: relative;
          margin-right: 14px;
          a {
            font-size: 15px;
          }
          &:nth-child(1)::after {
            content: "";
            width: 1px;
            height: 24px;
            right: -10px;
            top: 12px;
            background: #e9ebec;
            position: absolute;
          }
          &.activeTab {
            border-bottom: 2px solid #409EFF;
            a {
              color: #409EFF
            }
          }
        }

      }
      .header-buttons {
        float: right;
        .el-dropdown {
          margin-left: 15px;
        }
        > .el-button {
          margin-left: 10px;
          padding: 6px 8px;
        }
        .loading-attr-button{
          background-color: #909399;
          border-color: #909399;
        }
      }
    }
    .procee-form-tab.el-tabs--card{
      .el-tabs__header {
        .el-tabs__nav {
          border:none;
        }
      }
      .el-tabs__item {
        height: 28px;
        line-height: 28px;
        color: #AFB0B1;
        border:none;
        border-bottom:1px solid #E4E7ED;
        &:hover {
          color:#54ABF1;
        }
        &:active {
          color : #29282E;
        }
        &.is-disabled {
          color: #C0C4CC;
          cursor: not-allowed;
        }
        &.is-active {
          border:1px solid #E4E7ED;
          border-bottom:none;
          color : #29282E;
          position: relative;
          &::after {
            position: absolute;
            content: "";
            width: 100%;
            height: 2px;
            background: #fff;
            bottom:-1px;
            left: 0;
          }
        }
      }
    }
  }

  .el-dropdown {
    height: 30px;
    line-height: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/process/design/process-design.vue